export default __webpack_public_path__ + "static/media/dtsd5168-6.b7148586.png";